<template>
   <div>
     <gmap-map
       :center="center"
       :zoom="zoom"
       style="width: 100%; height: 800px"
     >
       <gmap-marker
         v-for="(marker, index) in markers"
         :key="index"
         :position="marker.position"
         :title="marker.title"
       ></gmap-marker>
     </gmap-map>
   </div>
 </template>
 
 <script>
 export default {
   data() {
     return {
       center: { lat: 23.74814, lng: 90.40943 }, // Initial map center
       zoom: 15, // Initial zoom level
       markers: [
         { position: { lat: 23.74814, lng: 90.40943 } , title:'Fahim Ahmed' }, // New York
         { position: { lat: 23.74715, lng: 90.40044 } , title:'Fahim Ahmed' }, // London
         { position: { lat: 23.70814, lng: 90.40943 } , title:'Fahim Ahmed' }, // Paris
         { position: { lat: 23.74015, lng: 90.40644 } , title:'Fahim Ahmed' }, // Paris
         { position: { lat: 23.70014, lng: 90.40943 } , title:'Fahim Ahmed' }, // Paris
         // Add more markers as needed
       ],
     }
   },
 }
 </script>
 